<template>
    <div>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">Informações TCU - BOLSISTAS</div>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Data Início da Baixa (DE)</label>
                        <date-picker
                            v-model="dataInicial"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Data Fim da Baixa (ATÉ)</label>
                        <date-picker
                            v-model="dataFinal"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <div
                    v-if="$v.$invalid"
                    class="d-block invalid-feedback ml-3 mb-3"
                    style="font-size: 100%;"
                >
                    Datas de Início e Fim são obrigatórias para o filtro.
                </div>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button variant="primary" 
                :disabled="$v.$invalid"
                @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import RelatoriosServicos from '../relatorios/RelatoriosServicos'
import download from '../../../shared/download'
import { required } from 'vuelidate/lib/validators'

export default {

    data() {
        return {
            mostrarModal: false,
            dataInicial: null,
            dataFinal: null
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.dataInicial = null
            this.dataFinal = null
        },

        filtrar() {
            let filtroDto = {}
            filtroDto.dataInicial = this.$moment(this.dataInicial,'DD/MM/YYYY').format('YYYY-MM-DD')
            filtroDto.dataFinal = this.$moment(this.dataFinal,'DD/MM/YYYY').format('YYYY-MM-DD')
            RelatoriosServicos.obterFiltroBolsistas(filtroDto).then(
                response => {
                    this.$store.dispatch('removeRequest')
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao obter relatório',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                                this.$toast.success(
                                        'Relatório gerado com sucesso',
                                        'SUCESSO',
                                        this.$toastConfig.success
                                    )
                                download(
                                    response,
                                    `Relatorios_BOLSISTAS_TCU - ${this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                                'DD-MM-YYYY'
                            )} - ${this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                                'DD-MM-YYYY'
                            )}.xlsx`
                        )
                        }
                        this.fechar()
                    } else {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } 
                    this.fechar()
                })
                this.$store.dispatch('removeRequest')
            
        }
    },
    computed: 
    {

    },
    validations: {
        dataFinal: {            
            required
        },
        dataInicial: {
            required
        }
    }

}
</script>
